import type { JsonObject } from "@/api";
import { normalizeYaml } from "./recipe";
import { applyOverridesToYaml } from "./recipe/recipeYaml";
import {
  activeConfigYaml,
  buildEffectiveYaml,
  effectiveConfigOverridePairs,
  type KeyValuePair,
  type SubmitConfigState,
} from "./submitWizardForm";

export type ConfigRenderModel = {
  originalYaml: string;
  effectiveYaml: string;
  overrideRows: KeyValuePair[];
};

// 구성/확정 스텝의 config 표시를 위한 단일 순수 렌더 모델. 초기 렌더와 업데이트 렌더가 모두 이
// 함수를 거치므로, 전체 본문 editor 와 diff 입력이 같은 의미 규칙을 따른다.
// `overridesOverride` 를 주면(확정 스텝의 BE preview 결과. 채널 mux 주입 포함) 그 override
// 집합으로 effectiveYaml 을 계산한다. 그래서 diff 가 실제 제출물과 같다. 두 경우 모두 적용
// 대상은 activeConfigYaml(제출에 포함되는 본문)이다. 원본에 적용하면 편집이 diff 에서 사라진다.
export function buildConfigRenderModel(
  config: SubmitConfigState,
  overridesOverride?: JsonObject,
): ConfigRenderModel {
  const overrideRows = effectiveConfigOverridePairs(config);
  const effectiveYaml =
    overridesOverride === undefined
      ? buildEffectiveYaml(config)
      : applyOverridesToYaml(activeConfigYaml(config), overridesOverride);
  return {
    originalYaml: normalizeYaml(config.inlineYaml),
    effectiveYaml: normalizeYaml(effectiveYaml),
    overrideRows,
  };
}
